import { render, staticRenderFns } from "./ReportProblemsForm.vue?vue&type=template&id=d8deb36a"
import script from "./ReportProblemsForm.vue?vue&type=script&lang=js"
export * from "./ReportProblemsForm.vue?vue&type=script&lang=js"
import style0 from "./ReportProblemsForm.vue?vue&type=style&index=0&id=d8deb36a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports